<!---- 
  -- This is the default layout for all marketing (i.e., non-app) pages.
  -- It sets up:
  --  * Navbar/header/footer
  --
  -- It inherits from /routes/__layout-base.svelte, which sets up analytics
  -- and error/exception tracking.
  ---->
<script lang="ts">
  import { setHighContrastIfNotManuallySet } from '$lib/stores/highContrastTheme.store';
  import { onMount } from 'svelte';

  import Footer from '$lib/teach/Footer.svelte';
  import Header from '$lib/teach/Header.svelte';
  import { highContrastStore } from '$lib/stores/highContrastTheme.store';
  import LoginModal from '$lib/app/modals/authentication/LoginModal.svelte';
  import RegisterModal from '$lib/app/modals/authentication/RegisterModal.svelte';
  import { goto } from '$app/navigation';
  import { closeModal } from '$lib/stores/modals.store';

  onMount(() => {
    setHighContrastIfNotManuallySet(!!window.matchMedia('(prefers-contrast: more)').matches);
  });

  let highContrast = false;
  highContrastStore.subscribe((bool) => {
    highContrast = bool;
  });

  function loginRegisterRedirect() {
    goto('/app').then(() => {
      closeModal();
    });
  }
</script>

<div class:high-contrast={highContrast}>
  <Header />
  <LoginModal on:loginComplete={loginRegisterRedirect} />
  <RegisterModal on:registrationComplete={loginRegisterRedirect} />

  <slot />

  <Footer />
</div>
